import { render, staticRenderFns } from "./CategorySidebar.vue?vue&type=template&id=77c74698&"
import script from "./CategorySidebar.vue?vue&type=script&lang=js&"
export * from "./CategorySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports